import { useEffect } from 'react'
import { useField } from 'remix-validated-form'

interface CloudflareTurnstileProps {
  name: string
  cloudflareTurnstileSiteKey?: string
}

export function CloudflareTurnstile(props: CloudflareTurnstileProps) {
  const { error } = useField(props.name)
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
    script.defer = true
    document.head?.appendChild(script)

    return () => {
      if (document.head?.contains(script)) {
        document.head.removeChild(script)
      }
    }
  }, [])

  return (
    <>
      <div
        className="cf-turnstile"
        data-response-field-name={props.name}
        data-sitekey={props.cloudflareTurnstileSiteKey}
        data-language="zh"
        data-theme="light"
      ></div>

      {error && <span className="text-sm text-danger-500">{error}</span>}
    </>
  )
}
